import script from "./RemoveOfferModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveOfferModal.vue?vue&type=script&setup=true&lang=js"

import "./RemoveOfferModal.vue?vue&type=style&index=0&id=fd4a4406&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd4a4406"]])

export default __exports__